/*
 * Verticale productgalerij.
 *
 * De carousel is vervangen door foto's onder elkaar. Dit script neemt over wat
 * Flickity deed: bijhouden welke foto in beeld is, de miniaturen daarop
 * afstemmen, en bij een variantwissel naar de juiste foto springen.
 *
 * De teller telt alleen zichtbare foto's. Staat "variantbeelden verbergen"
 * aan, dan verschilt dat aantal per gekozen kleur.
 */
(function () {
  'use strict';

  var DESKTOP = '(min-width: 1068px)';

  function Galerij(root) {
    this.root = root;
    this.mediaKolom = root.querySelector('.product-images--vertical');
    this.slides = [];
    this.huidig = -1;

    if (!this.mediaKolom) return;

    this.streepjes = root.querySelector('[data-gallery-streepjes]');
    this.thumbs = root.querySelectorAll('.product-thumbnail');

    this.verzamel();
    this.koppelThumbs();
    this.volgScroll();
    this.markeer(0);
  }

  /* Alleen zichtbare slides tellen mee: verborgen variantbeelden niet. */
  Galerij.prototype.verzamel = function () {
    var alle = this.mediaKolom.querySelectorAll('.product-images__slide');
    this.slides = [];

    for (var i = 0; i < alle.length; i++) {
      if (alle[i].classList.contains('is-active')) this.slides.push(alle[i]);
    }

    this.tekenStreepjes();
  };

  /* Eén streepje per zichtbare foto. Bij een kleurwissel verandert dat aantal,
     dus bouwen we ze opnieuw op in plaats van ze vast in de opbouw te zetten. */
  Galerij.prototype.tekenStreepjes = function () {
    if (!this.streepjes) return;
    if (this.streepjes.childNodes.length === this.slides.length) return;

    this.streepjes.innerHTML = '';
    for (var i = 0; i < this.slides.length; i++) {
      var streep = document.createElement('span');
      streep.className = 'product-gallery-meta__streep';
      this.streepjes.appendChild(streep);
    }
    this.huidig = -1;
  };

  Galerij.prototype.mediaSleutel = function (el) {
    // Slide: id="Slide-<section>-<media>", thumb: id="Thumb-<section>-<media>"
    var id = el.id || '';
    var deel = id.split('-');
    return deel.length > 1 ? deel.slice(1).join('-') : id;
  };

  Galerij.prototype.koppelThumbs = function () {
    var self = this;

    for (var i = 0; i < this.thumbs.length; i++) {
      (function (thumb) {
        thumb.addEventListener('click', function (e) {
          e.preventDefault();
          var sleutel = self.mediaSleutel(thumb);

          for (var s = 0; s < self.slides.length; s++) {
            if (self.mediaSleutel(self.slides[s]) === sleutel) {
              self.springNaar(self.slides[s]);
              break;
            }
          }
        });
      })(this.thumbs[i]);
    }
  };

  Galerij.prototype.springNaar = function (slide) {
    if (!slide) return;

    var vloeiend = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (window.matchMedia(DESKTOP).matches) {
      var top = window.pageYOffset + slide.getBoundingClientRect().top;
      window.scrollTo({ top: top, behavior: vloeiend ? 'smooth' : 'auto' });
    } else {
      // Op mobiel staan de foto's naast elkaar in een veegbare rij.
      this.mediaKolom.scrollTo({
        left: slide.offsetLeft,
        behavior: vloeiend ? 'smooth' : 'auto',
      });
    }
  };

  Galerij.prototype.markeer = function (index) {
    if (index === this.huidig || index < 0) return;
    this.huidig = index;

    if (this.streepjes) {
      var strepen = this.streepjes.childNodes;
      for (var s = 0; s < strepen.length; s++) {
        if (s === index) strepen[s].classList.add('is-actief');
        else strepen[s].classList.remove('is-actief');
      }
    }

    var actief = this.slides[index];
    var sleutel = actief ? this.mediaSleutel(actief) : null;

    for (var i = 0; i < this.thumbs.length; i++) {
      var thumb = this.thumbs[i];
      thumb.classList.toggle('is-current', sleutel !== null && this.mediaSleutel(thumb) === sleutel);
    }
  };

  Galerij.prototype.volgScroll = function () {
    var self = this;

    if (!('IntersectionObserver' in window)) return;

    // De foto die het dichtst bij het midden van het scherm staat, geldt als
    // de huidige. Een enkele drempel zou bij hoge foto's te vroeg omslaan.
    this.observer = new IntersectionObserver(
      function (entries) {
        var beste = null;
        var besteRatio = 0;

        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio > besteRatio) {
            besteRatio = entry.intersectionRatio;
            beste = entry.target;
          }
        });

        if (!beste) return;

        var index = self.slides.indexOf(beste);
        if (index !== -1) self.markeer(index);
      },
      { threshold: [0.25, 0.5, 0.75] }
    );

    for (var i = 0; i < this.slides.length; i++) this.observer.observe(this.slides[i]);
  };

  /* Na een variantwissel kan de set zichtbare foto's veranderd zijn. */
  Galerij.prototype.herzie = function (mediaId) {
    if (this.observer) this.observer.disconnect();

    this.verzamel();
    this.huidig = -1;
    this.volgScroll();

    if (mediaId) {
      for (var i = 0; i < this.slides.length; i++) {
        if (this.slides[i].id.indexOf('-' + mediaId) !== -1) {
          this.springNaar(this.slides[i]);
          this.markeer(i);
          return;
        }
      }
    }

    this.markeer(0);
  };

  /* ----------------------------------------------------------------------
   * Prijs in de koopknop gelijk houden aan de gekozen variant.
   *
   * Het thema herrendert bij een variantwissel een vaste set elementen, en de
   * koopknop hoort daar niet bij. Het prijsblok wél — daar nemen we het bedrag
   * uit over, zodat opmaak van valuta en kortingen het werk van Liquid blijft.
   * -------------------------------------------------------------------- */

  function koppelPrijsAanKnop(root) {
    var knopPrijs = root.querySelector('.single-add-to-cart-button--price');
    if (!knopPrijs) return;

    var priceEl = null;
    var kandidaten = root.querySelectorAll('[id^="price-"]');
    for (var i = 0; i < kandidaten.length; i++) {
      if (kandidaten[i].id.indexOf('--sticky') === -1) {
        priceEl = kandidaten[i];
        break;
      }
    }
    if (!priceEl) return;

    var sync = function () {
      // <ins> bevat de actuele prijs; <del> is de doorgestreepte adviesprijs.
      var actueel = priceEl.querySelector('ins .amount') || priceEl.querySelector('.amount');
      var bedrag = actueel ? actueel.textContent.trim() : '';
      if (bedrag && bedrag !== knopPrijs.getAttribute('data-content')) {
        knopPrijs.setAttribute('data-content', bedrag);
      }
    };

    new MutationObserver(sync).observe(priceEl, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    sync();
  }

  /* ----------------------------------------------------------------------
   * Vangnet voor de koopknop na een maatwissel.
   *
   * De variantlogica van het thema schakelt bij elke wissel eerst de knop uit
   * en pas na afloop weer in. Breekt die keten onderweg af, dan blijft de knop
   * uitgeschakeld staan en kan er niets meer in het mandje — ook niet de maat
   * die daarvoor nog wel werkte. In updateMedia() staat bijvoorbeeld een
   * aanroep zonder controle op een ontbrekend element.
   *
   * Deze code leidt de gekozen variant zelf af uit de aangevinkte opties,
   * herstelt de knopstatus en zet het juiste variant-id in het formulier.
   * Werkt de logica van het thema wel, dan doet dit hetzelfde nog eens —
   * zonder bijwerking.
   * -------------------------------------------------------------------- */

  function variantUitOpties(root) {
    var json = root.querySelector('script[type="application/json"]');
    if (!json) return null;

    var data;
    try {
      data = JSON.parse(json.textContent);
    } catch (e) {
      return null;
    }
    if (!Array.isArray(data)) return null;

    var gekozen = [];
    var velden = root.querySelectorAll('fieldset');
    for (var i = 0; i < velden.length; i++) {
      var aan = velden[i].querySelector('input:checked');
      var keuze = velden[i].querySelector('select');
      if (aan) gekozen.push(aan.value);
      else if (keuze) gekozen.push(keuze.value);
    }
    if (!gekozen.length) return null;

    for (var v = 0; v < data.length; v++) {
      var opties = data[v].options || [];
      var raak = opties.length === gekozen.length;
      for (var o = 0; raak && o < opties.length; o++) {
        if (opties[o] !== gekozen[o]) raak = false;
      }
      if (raak) return data[v];
    }
    return null;
  }

  function herstelKoopknop(root) {
    var variant = variantUitOpties(root);
    if (!variant) return;

    // Het formulier moet het juiste variant-id meesturen.
    var form = document.getElementById('product-form-' + root.dataset.section);
    if (form) {
      var idVeld = form.querySelector('input[name="id"]');
      if (idVeld) idVeld.value = variant.id;
    }

    var knoppen = document.querySelectorAll('.single-add-to-cart-button');
    for (var i = 0; i < knoppen.length; i++) {
      if (variant.available) {
        knoppen[i].removeAttribute('disabled');
        knoppen[i].removeAttribute('aria-disabled');
        knoppen[i].classList.remove('sold-out', 'loading');
      } else {
        knoppen[i].setAttribute('disabled', 'disabled');
      }
    }
  }

  document.addEventListener(
    'change',
    function (event) {
      var doel = event.target;
      if (!doel || !doel.closest) return;

      var root = doel.closest('variant-selects');
      if (!root) return;

      // Even wachten tot het thema klaar is met zijn eigen afhandeling.
      setTimeout(function () {
        herstelKoopknop(root);
      }, 150);
    },
    true
  );

  var galerijen = [];

  function init() {
    galerijen = [];
    var roots = document.querySelectorAll('.product-gallery--vertical');
    for (var i = 0; i < roots.length; i++) galerijen.push(new Galerij(roots[i]));

    var rasters = document.querySelectorAll('.product-grid--vertical');
    for (var r = 0; r < rasters.length; r++) koppelPrijsAanKnop(rasters[r]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  document.addEventListener('product:variant-change', function (event) {
    var detail = event.detail || {};
    var mediaId = detail.variant && detail.variant.featured_media
      ? detail.variant.featured_media.id
      : null;

    // De slides krijgen hun is-active class van het thema; even wachten tot
    // die verwerkt is voordat we opnieuw tellen.
    setTimeout(function () {
      for (var i = 0; i < galerijen.length; i++) galerijen[i].herzie(mediaId);
    }, 60);
  });
})();
